// 专门处理ResizeObserver错误的工具函数

export const setupResizeObserverErrorHandler = () => {
  // 保存原始方法
  const originalAddEventListener = window.addEventListener;
  
  // 重写全局错误处理，在最早阶段拦截
  const errorHandler = (event: Event) => {
    const errorEvent = event as ErrorEvent;
    if (errorEvent.message && (
      errorEvent.message.includes('ResizeObserver loop completed with undelivered notifications') ||
      errorEvent.message.includes('ResizeObserver loop limit exceeded') ||
      errorEvent.message.includes('ResizeObserver')
    )) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  };

  // 立即添加错误处理器
  originalAddEventListener.call(window, 'error', errorHandler, true);

  // 重写console.error以隐藏ResizeObserver错误
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;

  console.error = (...args: any[]) => {
    const message = args.join(' ');
    if (message.includes('ResizeObserver')) {
      return;
    }
    originalConsoleError.apply(console, args);
  };

  console.warn = (...args: any[]) => {
    const message = args.join(' ');
    if (message.includes('ResizeObserver')) {
      return;
    }
    originalConsoleWarn.apply(console, args);
  };

  // 处理webpack-dev-server的错误覆盖层
  const hideWebpackErrorOverlay = () => {
    const observer = new MutationObserver(() => {
      const errorOverlay = document.querySelector('div[id*="webpack"]');
      if (errorOverlay) {
        const errorContent = errorOverlay.textContent || errorOverlay.innerHTML;
        if (errorContent.includes('ResizeObserver')) {
          (errorOverlay as HTMLElement).style.display = 'none';
        }
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // 定期检查并隐藏错误覆盖层
    setInterval(() => {
      const errorOverlay = document.querySelector('div[id*="webpack"], div[data-reactroot] div[style*="position: fixed"]');
      if (errorOverlay) {
        const errorContent = errorOverlay.textContent || errorOverlay.innerHTML;
        if (errorContent.includes('ResizeObserver')) {
          (errorOverlay as HTMLElement).style.display = 'none';
        }
      }
    }, 100);
  };

  // DOM加载完成后执行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideWebpackErrorOverlay);
  } else {
    hideWebpackErrorOverlay();
  }

  // 重写ResizeObserver
  if (typeof ResizeObserver !== 'undefined') {
    const OriginalResizeObserver = ResizeObserver;
    
    (window as any).ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback: ResizeObserverCallback) {
        const wrappedCallback: ResizeObserverCallback = (...args) => {
          window.requestAnimationFrame(() => {
            try {
              callback(...args);
            } catch (e) {
              // 忽略所有ResizeObserver错误
            }
          });
        };
        super(wrappedCallback);
      }
    };
  }
};